export default __webpack_public_path__ + "static/identity-mock-m13-d05707bceddcfb9e093b1b1d6d57542c.png";